import { useSelector } from "react-redux";
import ProcessNamePackages from "./PieChartComponent/ProcessNamePackages";
import RunMethodPackages from "./PieChartComponent/RunMethodPackages";
import StatusPackages from "./PieChartComponent/StatusPackages";
import { Typography } from "@mui/material";
import { useMemo } from "react";
import {
  getFilteredSummary,
} from "../../../../../utils/helpers";
import Grid from "@mui/material/Grid";

const PackagesPieChart = () => {
  const { packageSummeryData } = useSelector(
    (state: any) => state.monitoringPackages
  );

  //--- By default Get process name, status, and run method data
  const processName = useMemo(
    () => getFilteredSummary(packageSummeryData?.summary_by_process_name),
    [packageSummeryData?.summary_by_process_name]
  );

  const statusName = useMemo(
    () => getFilteredSummary(packageSummeryData?.summary_by_status),
    [packageSummeryData?.summary_by_status]
  );

  const executionType = useMemo(
    () => getFilteredSummary(packageSummeryData?.summary_by_execution_type),
    [packageSummeryData?.summary_by_execution_type]
  );

  //-- If filterDataList is not empty then find the count of each process name, status, and run method
  // const { processNames, statuses, runMethods } = useMemo(() => {
  //   const processNames = {} as any;
  //   const statuses = {} as any;
  //   const runMethods = {} as any;

  //   filterDataList?.forEach((item: any) => {
  //     // Process Name Count
  //     const pname = item.process_name?.toUpperCase() || "unknown";
  //     processNames[pname] = (processNames[pname] || 0) + 1;

  //     // Status Count
  //     const status = item.status?.toUpperCase() || "UNKNOWN";
  //     statuses[status] = (statuses[status] || 0) + 1;

  //     // Run Method Count
  //     const runMethod = item.run_method?.toUpperCase() || "UNKNOWN";
  //     runMethods[runMethod] = (runMethods[runMethod] || 0) + 1;
  //   });

  //   return { processNames, statuses, runMethods };
  //   // eslint-disable-next-line
  // }, [filterDataList]);

  return (
    <>
      <Typography sx={{ fontSize: "24px", mt: 1, fontWeight: "500" }}>
        Total number of packages: {packageSummeryData?.num_of_records ? packageSummeryData?.num_of_records : 0}
      </Typography>
      <Grid container spacing={2} mt={2} pb={2} width={"100%"}>
        <Grid item xs={12} lg={6} sm={6} md={12} xl={4}>
          <ProcessNamePackages data={processName} />
        </Grid>
        <Grid item xs={12} lg={6} sm={6} md={12} xl={4}>
          <StatusPackages data={statusName} />
        </Grid>
        <Grid item xs={12} lg={12} sm={12} md={12} xl={4}>
          <RunMethodPackages data={executionType} />
        </Grid>
      </Grid>
    </>
  );
};

export default PackagesPieChart;
